export const namespace = 'dashboard';

export const MutationTypes = {
  SET_STATS: 'SET_STATS',
};

export const ActionTypes = {
  GET_STATS: 'GET_STATS',
};
